// packages/app/src/components/Root/LogoIcon.tsx
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 32,
  },
});

// Collapsed sidebar — show just the "DISCOUNT TIRE" wordmark cropped to
// the left portion (D + I letters) which reads as the brand mark at small size.
// We reuse the exact official SVG but clip to the left ~55px (the "DI" block).
const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.svg}
      src="https://cdn.discounttire.com/sys-master/images/hc5/h31/8808331083806/DT_logo.svg"
      alt="Discount Tire"
      style={{ height: 32, width: 'auto' }}
    />
  );
};

export default LogoIcon;
